import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_TIBBERPRICE_REGISTRY_KEY, META_TYPE, META_VER } from './tibberPriceCommandRegisteryType';

/**
 * Registers the /tibber command with the CommandEngine.
 * /tibber — opens/refocuses the Tibber price list (single instance, target=tibber).
 */
export function registerTibberPriceCommand() {
    commandEngine.register('/tibber', {
        hint: 'open Tibber prices (list + best charge window)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_TIBBERPRICE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'tibber' }, {});
        },
    });
}
